import { Vue, Component } from 'vue-property-decorator'
import LinkSelector from '~/components/element/LinkSelector'
import LinkItem from '~/types/LinkItem'
import ArticleCategory from '~/types/api/news/ArticleCategory'
import s from '~/utils/s'

@Component
export default class NewsHeader extends Vue {
  get selectedCategory (): string {
    const query = this.$route.query
    let category = 0
    if (typeof query.category === 'string' && !isNaN(parseInt(query.category, 10))) {
      category = parseInt(query.category, 10)
    }
    if (s(this.$store).newsPage.categories.find(e => e.id === category) === undefined) {
      category = 0
    }
    return category.toString()
  }

  get categoryList (): LinkItem[] {
    const query = this.$route.query
    const get = (v: ArticleCategory) => (
      {
        code: v.id.toString(),
        title: v.name,
        location: {
          path: this.$route.path,
          query: {
            ...query,
            category: v.id.toString()
          }
        }
      }
    )

    return [
      {
        code: '0',
        title: 'Все категории',
        location: {
          path: this.$route.path,
          query: {
            ...query,
            category: '0'
          }
        }
      },
      ...s(this.$store).newsPage.categories.map(e => get(e))
    ]
  }

  render () {
    return (
      <div class="entity-list-header">
        <div class="entity-list-header__content">
          <h1 class="entity-list-header__content-header">
            Новости
          </h1>
        </div>
        <div class="entity-list-header__sort">
          <div class="entity-list-header__sort-product">
            <LinkSelector {...{
              props: {
                items: this.categoryList,
                selected: this.selectedCategory
              }
            }} />
          </div>
        </div>
      </div>
    )
  }
}
